import localStorageService from "./local-storage-service";

export const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
};
export const isBusinessAdminUser = () => {
    const role = localStorageService.getRole();
    return role.toUpperCase() === "ADMIN-BUSINESS";
}
export const isRescueRnAdmin = () => {
    const role = localStorageService.getRole();
    return role?.toUpperCase() === "ADMIN";
}
export const getBusinessId = () => {
    const userDetails = localStorageService.getUserDetails();
    return userDetails?.adminBusinessUsers[0]?._id;
}